

















































import { Component, Vue, Prop } from "vue-property-decorator";
import { Scheme } from "@foxone/api/src/models/defi";
import { SchemeType, SchemeProgress, Asset } from "@foxone/api/src/models/defi";
import DualNodeAvaliableState from "./DualNodeAvaliableState.vue";
import utils from "defi/utils";

@Component({
  components: {
    DualNodeAvaliableState
  }
})
class SchemeItem extends Vue {
  @Prop() scheme!: Scheme;

  get meta() {
    const scheme = this.scheme;
    const toPercent = this.$common.utils.number.toPercent;
    const getColor = this.$common.utils.helper.getColor;
    const getProgressMeta = utils.enums.getSchemeProgressMeta;

    let interestRatio = "0";
    if (scheme.type !== SchemeType.POOL) {
      interestRatio = scheme.interest_ratio;
    }

    let asset: Asset;
    if (scheme.type === SchemeType.DUAL_NODE) {
      asset = scheme.slave_asset;
    } else {
      asset = scheme.pay_asset;
    }

    const rate =
      +interestRatio === 0
        ? this.$t("common.tbd")
        : toPercent(interestRatio, true);

    const isDualNode = scheme.type === SchemeType.DUAL_NODE;
    return {
      rate,
      isDualNode,
      image: asset.icon,
      name: this.scheme.name,
      symbol: asset.symbol.toUpperCase(),
      rateColor: getColor(this.$store, interestRatio),
      status: getProgressMeta(this.scheme.progress)
    };
  }

  get disabled() {
    return this.scheme.progress !== SchemeProgress.OPENING;
  }

  get isFull() {
    const scheme = this.scheme;
    return SchemeProgress.FULL === scheme.progress;
  }

  get joinText() {
    return this.isFull ? this.$t("defi.node-full") : this.$t("common.join");
  }

  handleJoin() {
    this.$helper.toFusionPath(this, "defi", {
      name: "type-id",
      params: { type: this.scheme.type, id: this.scheme.id }
    });
  }
}
export default SchemeItem;
